import React, { useState } from 'react';
import { Svg } from 'components';
import { IconContainer, Text, Title, Wrapper, Description } from './styled';

interface ICategoryItem {
  categoryName: string;
  description: string;
  link: string;
  iconName: string;
}

function CategoryItem({
  link,
  iconName,
  description,
  categoryName
}: ICategoryItem): JSX.Element {
  const [isOpen, setOpen] = useState(false);
  const handleOpen = () => setOpen(!isOpen);
  return (
    <Wrapper data-testid="category-item">
      <IconContainer href={link} onClick={handleOpen}>
        <Svg className={iconName} name={iconName} />
      </IconContainer>
      <Text>
        <Title href={link}>{categoryName}</Title>
        <Description>{description}</Description>
      </Text>
    </Wrapper>
  );
}

export default CategoryItem;
